'use client';
import gtm from '@/utils/gtm';

export default gtm;
